
const metadata = {
  'gift-card-small': {
    key: 'gift-card-small',
    name: 'Gift Card',
    baseID: 'GFT-0001',
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/GFT-0001.png',
    brand: 'Born This Day',
    prices: {
      SEK: 35000,
      DKK: 25000,
      EUR: 3500,
      USD: 4000,
      AUD: 5700
    }
  },
  'gift-card-medium': {
    key: 'gift-card-medium',
    name: 'Gift Card',
    baseID: 'GFT-0002',
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/GFT-0002.png',
    brand: 'Born This Day',
    prices: {
      SEK: 54000,
      DKK: 40000,
      EUR: 5400,
      USD: 6300,
      AUD: 8800
    }
  },
  'gift-card-large': {
    key: 'gift-card-large',
    name: 'Gift Card',
    baseID: 'GFT-0003',
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/GFT-0003.png',
    brand: 'Born This Day',
    prices: {
      SEK: 64000,
      DKK: 47000,
      EUR: 7000,
      USD: 7900,
      AUD: 11400
    }
  }
}

const deliveryMethod = [
  'digital',
  'printed'
]

export default {
  strict: true,

  state: { },

  mutations: { },

  actions: { },

  getters: {
    giftCardDeliveryMethods () {
      return JSON.parse(JSON.stringify(deliveryMethod))
    },
    giftCardsMetadata () {
      return JSON.parse(JSON.stringify(metadata))
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/gift-cards.js